module.exports = __webpack_public_path__ + "static/media/fishing_marker_dark_blue.af6a5203.svg";